import {call, fork, put, select} from "redux-saga/effects";
import {fetchCategories} from "../actions";
import {IApplicationState} from "../../index";
import makeMap from "../../../shared/utils/makeMap";
import preloadImages from "./preloadImages";
import {ICategoryApiResponse} from "./types";
import apiCall from "../../../shared/utils/apiCall";
import {trackError} from "../../log/actions";
import {LogLevel} from "../../log/types";
import {ICategory} from "../types";

let firstTime = true;

type StateCutOff = {
    existingCategories: Record<number, ICategory>,
    categoriesFetchTime: number,
}

export default function* handleFetchCategories() {
    try {
        const {existingCategories, categoriesFetchTime}: StateCutOff = yield select(({ settings, game }: IApplicationState) => ({
            existingCategories: game.categories,
            categoriesFetchTime: game.categoriesFetchTime,
        }));

        const now = new Date();
        const dayAgo = now.setDate(now.getDate() - 1);
        if (Object.keys(existingCategories).length && categoriesFetchTime > dayAgo) {
            if (firstTime) {
                yield fork(preloadImages, Object.values(existingCategories).map(category => category.imageUrl));
                firstTime = false;
            }

            return;
        }

        yield put(fetchCategories.request());

        const response: ICategoryApiResponse = yield call(apiCall, {
            params: {
                section: "categories",
                method: "get",
            }
        });

        yield fork(preloadImages, response.data.map(category => category.imageUrl));

        const data = makeMap(response.data, "id");

        yield put(fetchCategories.success(data));
    } catch (error) {
        yield put(trackError({
            logLevel: LogLevel.Fatal,
            category: "FetchCategories",
            message: "Failed to fetch categories",
            error: error,
        }));

        yield put(fetchCategories.failure({
            message: error
        }));
    }
}